export const getDownshiftEnvironment = container => {
  const rootNode = container?.()?.getRootNode?.();

  if (String(rootNode) === '[object ShadowRoot]') {
    // Create a polyfill for Downshift to not throw errors when appended to a shadow DOM
    // See: https://github.com/downshift-js/downshift/issues/834
    rootNode.createElement = (...args) =>
      rootNode.ownerDocument.createElement(...args);

    const downshiftPolyfill = rootNode.createElement('div');

    downshiftPolyfill.id = 'a11y-status-message';
    downshiftPolyfill.style.display = 'none';

    rootNode.appendChild(downshiftPolyfill);

    // Necessary properties for Downshift to register clicks inside a shadow DOM.
    // See: https://github.com/downshift-js/downshift/issues/536
    return {
      document: rootNode,
      addEventListener: rootNode.addEventListener.bind(rootNode),
      removeEventListener: rootNode.removeEventListener.bind(rootNode),
    };
  }

  if (typeof window === 'undefined') {
    return null;
  }

  return window;
};
